export default __webpack_public_path__ + "static/premioEC-43c75680cad5f298e9fdcd398792906d.gif";